define('lib/Podio.Gravity',['require','underscore','jquery','lib/jquery/jquery.removeClassByPrefix','lib/Podio.Viewport','lib/Podio.Browser'],function(require) {
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.removeClassByPrefix');
  var PodioViewport = require('lib/Podio.Viewport');
  var podioBrowser = require('lib/Podio.Browser');

  var GravityHelper = function(options) {
    this.options = options = options || {};

    this.gravityPriorities = options.gravityPriorities || ['n', 'w', 'e', 's'];
    this.arrowSpacing = _.isUndefined(options.arrowSpacing) ? 20 : options.arrowSpacing;
    this.viewportHelper = options.viewportHelper || new PodioViewport();
    this.elmWindow = options.elmWindow || $(window);
  };

  _.extend(GravityHelper.prototype, {
    calculateBestGravity: function(elmAttachmentTarget, elementToClone) {

      var bestGravity;

      // Build clone
      var elmClone = $('<div />', {
        css: {
          'height': elementToClone.outerHeight(true),
          'width': elementToClone.outerWidth(true),
          'position': 'absolute'
        }
      });
      elmClone.appendTo($('body'));

      // Loop
      for ( var i = 0; i < this.gravityPriorities.length; i++) {

        var targetGravity = this.gravityPriorities[i];

        if(bestGravity) {
          continue;
        }

        this.positionStepByGravity(targetGravity, elmClone, elmAttachmentTarget);
        var viewportInfo = this.viewportHelper.getInfo(elmClone);

        if(viewportInfo.isInViewport) {
          bestGravity = targetGravity;
        }

      }

      if(!bestGravity) {
        bestGravity = 'center';
      }

      // Remove clone
      elmClone.remove();

      return bestGravity;
    },

    calculateElementPositionByGravity: function(gravity, elmTarget, elmAttachmentTarget, arrowOffset, alignHorizontallyWithBalloonAnchor) {
      // Figure out position
      if (_.isUndefined(arrowOffset)) {
        arrowOffset = 75;
      }

      if(elmAttachmentTarget.data('arrow-alignment') && !arrowOffset) {
        if(elmAttachmentTarget.data('arrow-alignment') === 'right') {
          arrowOffset = elmTarget.outerWidth() - 75;
        }

        if(elmAttachmentTarget.data('arrow-alignment') === 'bottom') {
          arrowOffset = elmTarget.outerHeight() - 85;
        }
      }

      var arrowSpacing = this.arrowSpacing;

      var attachmentPos = elmAttachmentTarget.offset();
      var attachmentWidth = elmAttachmentTarget.outerWidth(true);
      var attachmentHeight = elmAttachmentTarget.outerHeight(true);

      var elmHeight = elmTarget.outerHeight(true);
      var elmWidth = elmTarget.outerWidth(true);

      var basePosition = {
        top: attachmentPos.top,
        left: attachmentPos.left,
        right: attachmentPos.left + attachmentWidth
      };

      var position;

      switch (gravity) {

      case 'center':
        position = {
          top: Math.floor(this.elmWindow.height() / 2) - Math.floor(elmHeight / 2) + this.elmWindow.scrollTop(),
          left: alignHorizontallyWithBalloonAnchor ? basePosition.left + Math.floor(attachmentWidth / 2) + arrowOffset : Math.floor(this.elmWindow.width() / 2) - Math.floor(elmWidth / 2)
        };

        break;
      case 'n':
        position = {
          top: basePosition.top + attachmentHeight + arrowSpacing,
          left: basePosition.left + Math.floor(attachmentWidth / 2) - arrowOffset
        };
        break;
      case 's':

        arrowOffset = (arrowOffset === 0) ? Math.floor(elmWidth / 2) : arrowOffset;

        position = {
          top: basePosition.top - elmHeight - arrowSpacing,
          left: basePosition.left + Math.floor(attachmentWidth / 2) - arrowOffset
        };

        break;
      case 'e':
        position = {
          top: basePosition.top - arrowOffset + Math.floor(attachmentHeight / 2),
          left: attachmentPos.left - elmWidth - arrowSpacing
        };

        break;
      case 'w':
        position = {
          top: basePosition.top - arrowOffset + Math.floor(attachmentHeight / 2),
          left: attachmentPos.left + attachmentWidth + arrowSpacing
        };
        break;
      }

      // Update positions
      elmTarget.removeClassByPrefix('gravity');
      elmTarget.addClass('gravity-' + gravity);

      return {
        elmTarget: elmTarget,
        position: position
      };
    },

    positionStepByGravity: function(gravity, elmTarget, elmAttachmentTarget, arrowOffset) {
      var calculatedElementPositionByGravity = this.calculateElementPositionByGravity(gravity, elmTarget,
          elmAttachmentTarget, arrowOffset);

      return this.updateElementStyle(calculatedElementPositionByGravity);
    },

    updateElementStyle: function(calculatedElementPositionByGravity) {
      var dfd = new $.Deferred();

      calculatedElementPositionByGravity.elmTarget.one(podioBrowser.cssTransitionEndEvent, function() {
        dfd.resolve();
      });

      calculatedElementPositionByGravity.elmTarget.css(calculatedElementPositionByGravity.position);

      return dfd;
    }
  });

  return GravityHelper;
});

